<template>
	<div>
		<!-- ------------------------------會員資訊開始------------------------------ -->
        <div class="modal fade cm-modal" id="memberModal" tabindex="-1" role="dialog"
            aria-labelledby="registerModalTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered cm-modal-member" role="document">
                <div class="modal-content">
                    <div class="modal-header p-0 text-center cm-modal-member-header">
                        <h4 class='col-12 modal-title text-center text-white'>
                            {{$t('modal.Member.Title')}}
                            <button type="button" class="close cm-member-close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">
                                    <img src="@/assets/images/login-close.png">
                                </span>
                            </button>
                        </h4>
                    </div>
                    <div class="modal-body px-sm-0 px-0 row no-gutters pb-5 cm-modal-member-body">
                        <div class="col-12 px-sm-5 px-0 py-4 row no-gutters">
                            <div class="col-md-4 col-12 px-0 d-flex justify-content-center cm-member-left-container">
                                <img :src="headImgPath" class="mh-100">
                            </div>
                            <div
                                class="col-md-8 col-12 px-1 justify-content-center align-items-end row no-gutters cm-member-right-container">
                                <div class="col-12 row no-gutters">
                                    <div class="col-12 text-center cm-member-account">
                                        {{account}}
                                    </div>
                                    
                                    <div v-if="isShowChangePasswordButton==true" class="col-sm-6 col-12 pt-sm-2 pt-1 pr-sm-1 pr-0 d-flex justify-content-center">
                                        <div v-if="isWaitingChangePasswordAjax==true" class="spinner-border text-warning text-center" role="status"></div>
                                        <button v-if="isWaitingChangePasswordAjax==false" @click="changePassword" class="btn btn-block rounded-0">{{$t('modal.Member.Button.ChangePassword')}}</button>
                                    </div>
                                    <div v-bind:class="bindEmailButtonCss">
                                        <div v-if="isWaitingChangeEmailAjax==true" class="spinner-border text-warning text-center" role="status"></div>
                                        <button 
                                            class="btn btn-block rounded-0"
                                            v-if="isShowBindEmailButton==true && isWaitingChangeEmailAjax==false && email==''"
                                            data-toggle="modal"
                                            data-target="#registerEmailModal"
                                        >
                                            {{$t('modal.Member.Button.BindEmail')}}
                                        </button>
                                        <button class="btn btn-block rounded-0" v-if="isWaitingChangeEmailAjax==false && email!=''" @click="changeEmail()">{{$t('modal.Member.Button.ChangeEmail')}}</button>
                                    </div>
                                    <div class="col-12 pt-sm-2 pt-1">
                                        <button class="btn btn-block rounded-0" @click="logoutService">{{$t('modal.Member.Button.Logout')}}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <img src="@/assets/images/cmi_logo_black.png" class="cm-member-logo-img">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- ------------------------------會員資訊結束------------------------------ -->
	</div>
</template>

<script>
import $ from 'jquery'
import axios from 'axios'
import store from '@/store/store-controller/store.js'
import eventBus from '@/assets/js/event/EventBus.js'
import RecaptchaUtil from "@/assets/js/util/RecaptchaUtil.js"
export default {
    data() {
        return {
            isInit: false,
            account: "",
            email: "",
            consigneeCode: "",
            gtHeadImgName: "member_gt.png",
            ggHeadImgName: "member_gg.png",
            fbHeadImgName: "member_fb.png",
            appleHeadImgName: "member_apple.png",
            headImgPath: "",
            isShowChangePasswordButton: true,
            isShowBindEmailButton: true,
            bindEmailButtonCss: "col-sm-6 col-12 pt-sm-2 pt-1 pr-sm-1 pr-0 d-flex justify-content-center",
            isWaitingChangePasswordAjax: false,
            isWaitingChangeEmailAjax: false
        }
    },
    mounted() {
        const self = this;
        eventBus.$on(process.env.VUE_APP_EVENT_EMIT_REFRESH_MEMBER_INFO_WHEN_GET_MEMBER_ACCOUNT_INFO, function() {
            self.init();
            self.isInit = true;
        });
    },
    methods: {
        init() {
            // consigneeCode
            this.consigneeCode = store.getters['storeMemberInfo/getConsigneeCode'];
            // 1.consigneeCode不為@GT時不顯示"修改密碼"按鈕
            // 2.consigneeCode不為@GT且未綁定的外部登入帳號不顯示"註冊信箱"按鈕
            if(this.consigneeCode!="@GT") {
                this.isShowChangePasswordButton = false;
                this.isShowBindEmailButton = false;
                this.bindEmailButtonCss = "col-12 pt-sm-2 pt-1 d-flex justify-content-center";
            }

            // 頭像
            let headImgName = this.gtHeadImgName;
            if(this.consigneeCode == "@google") {
                headImgName = this.ggHeadImgName;
            }
            else if(this.consigneeCode == "@facebook") {
                headImgName = this.fbHeadImgName;
            }
            else if(this.consigneeCode == "@apple") {
                headImgName = this.appleHeadImgName;
            }
            this.headImgPath = require('@/assets/images/' + headImgName);

            // 帳號
            if(this.consigneeCode=="@google" || this.consigneeCode=="@facebook" || this.consigneeCode=="@apple") {
                this.account = store.getters['storeMemberInfo/getGameAccount'];
            }
            else {
                this.account = store.getters['storeMemberInfo/getAccount'];
            }
            
            // 信箱
            const storeEmail = store.getters['storeMemberInfo/getEmail'];
            if(storeEmail!="" && storeEmail!="null" && storeEmail!=null && storeEmail!=undefined) {
                this.email = storeEmail;
            }
        },
        logoutService() {
            $('#memberModal').modal('hide');
            this.clearData();
            eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_MEMBER_LOGOUT);
        },
        clearData() {
            this.account = "";
            this.email = "";
            this.consigneeCode = "";
            this.headImgPath = "";
        },
        async changeEmail() { // 更換信箱
            // 未初始化
            if(this.isInit == false) {return;}
            
            // 確認信箱是否存在
            const account = store.getters['storeMemberInfo/getAccount'];
            let resultObj =  await this.checkEmail(account);

            // 信箱存在，發送修改密碼請求
            const self = this
            if(resultObj.status && resultObj.pixelatedEmail!="") {
                RecaptchaUtil.startGoogleRecaptchaVerify(
                    process.env.VUE_APP_AUTH_RECAPTCHA_SEND_EMAIL_TO_CHANGE_EMAIL,
                    async function(gRecaptchaResponse) {
                        let bodyFormData = new FormData();
                        bodyFormData.append("memberMultiId.subAccount", self.account);
                        bodyFormData.append("request_locale", self.$i18n.locale.replace("-", "_"));
                        bodyFormData.append("mydomain", "all9fun.com");
                        bodyFormData.append("g-recaptcha-response", gRecaptchaResponse);

                        // 開啟Ajax等待動畫
                        self.isWaitingChangeEmailAjax = true;

                        // Ajax
                        const response = await axios({
                            method: "post",
                            url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/sendEmailToChangeEmailAction.shtml",
                            timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                            data: bodyFormData,
                            config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
                        })
                        .catch(function(response) {
                            alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'))
                        })

                        // 關閉Ajax等待動畫
                        self.isWaitingChangeEmailAjax = false;

                        // 判斷Ajax結果
                        if(response!=undefined && response.data!=undefined) {
                            if(response.data.result=="success") {
                                let str = self.$i18n.t('modal.Member.Alert.ChangeEmail.SendEmailSuccess.sent1') + resultObj.pixelatedEmail + self.$i18n.t('modal.Member.Alert.ChangeEmail.SendEmailSuccess.sent2')
                                alert(str);
                            }
                            else {
                                alert("error");
                            }
                        }
                    }
                )
            }
        },
        async changePassword() { // 更換密碼
            // 未初始化
            if(this.isInit == false) {return;}
            
            // 確認信箱是否存在
            const account = store.getters['storeMemberInfo/getAccount'];
            let resultObj =  await this.checkEmail(account);

            // 信箱存在，發送修改密碼請求
            const self = this
            if(resultObj.status && resultObj.pixelatedEmail!="") {
                RecaptchaUtil.startGoogleRecaptchaVerify(
                    process.env.VUE_APP_AUTH_RECAPTCHA_SEND_EMAIL_TO_CHANGE_PASSWORD,
                    async function(gRecaptchaResponse) {
                        let bodyFormData = new FormData();
                        bodyFormData.append("memberMultiId.subAccount", self.account);
                        bodyFormData.append("textfield", resultObj.pixelatedEmail);
                        bodyFormData.append("request_locale", self.$i18n.locale.replace("-", "_"));
                        bodyFormData.append("mydomain", "all9fun.com");
                        bodyFormData.append("g-recaptcha-response", gRecaptchaResponse);
            
                        // 開啟Ajax等待動畫
                        self.isWaitingChangePasswordAjax = true;
    
                        // Ajax
                        const response = await axios({
                            method: "post",
                            url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/sendEmailToChangePasswordJsonAction.shtml",
                            timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                            data: bodyFormData,
                            config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
                        })
                        .catch(function(response) {
                            alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'))
                        })

                        // 關閉Ajax等待動畫
                        self.isWaitingChangePasswordAjax = false;
            
                        // 判斷Ajax結果
                        if(response!=undefined && response.data!=undefined) {
                            if(response.data.result=="success") {
                                let str = self.$i18n.t('modal.Member.Alert.ChangePassword.SendEmailSuccess.sent1') + resultObj.pixelatedEmail + self.$i18n.t('modal.Member.Alert.ChangePassword.SendEmailSuccess.sent2')
                                alert(str);
                            }
                            else {
                                alert("error");
                            }
                        }
                    }
                );    
            }
        },
        async checkEmail(account) { // 確認信箱是否存在
            let resultObj = {
                status: false,
                pixelatedEmail: ""
            }

            // 未初始化
            if(this.isInit == false) {
                return resultObj;
            }

            if(this.email=="null" || this.email==null || this.email==undefined || this.email=="") {
                alert(this.$i18n.t('modal.Member.Alert.UnregisteredEmail'));
            }
            else {
                // Ajax
                let bodyFormData = new FormData();
                bodyFormData.append("memberMultiId.subAccount", account);
                bodyFormData.append("request_locale", this.$i18n.locale.replace("-", "_"));
                const self = this;
                const response = await axios({
                    method: "post",
                    url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/retrieveEamilAction.shtml",
                    timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                    data: bodyFormData,
                    config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
                })
                .catch(function(response) {
                    alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'))
                })
    
                // 判斷Ajax回傳結果
                if(response!=undefined && response.data!=undefined) {
                    if(response.data.status=="success") {
                        resultObj.status = true;
                        resultObj.pixelatedEmail = response.data.email; // 取得已馬了n碼的信箱
                    }
                    else if(response.data.status=="fail") {
                        alert(response.data.message)
                    }
                }
            }
            return resultObj;
        }
    },
}
</script>